export default __webpack_public_path__ + "static/2-error-bebc39c515e5da9d7edb0b295657693a.png";